import React, { useEffect, useRef, useState } from 'react';

type Variant = 'up' | 'left' | 'right';

const VARIANT_CLASS: Record<Variant, string> = {
  up: 'HomeV10-reveal',
  left: 'HomeV10-revealLeft',
  right: 'HomeV10-revealRight'
};

const DELAY_CLASS: Record<number, string | undefined> = {
  1: 'HomeV10-revealD1',
  2: 'HomeV10-revealD2',
  3: 'HomeV10-revealD3',
  4: 'HomeV10-revealD4'
};

interface Props {
  children: React.ReactNode;
  variant?: Variant;
  delayStep?: 0 | 1 | 2 | 3 | 4;
  className?: string;
}

const Reveal: React.FC<Props> = ({ children, variant = 'up', delayStep = 0, className }) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const obs = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setVisible(true);
          } else {
            setVisible(false);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -20px 0px' }
    );

    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  const base = VARIANT_CLASS[variant];
  const delay = delayStep > 0 ? DELAY_CLASS[delayStep] : undefined;
  const combined = [base, delay, className, visible ? 'is-visible' : ''].filter(Boolean).join(' ');

  return (
    <div ref={ref} className={combined}>
      {children}
    </div>
  );
};

export default Reveal;
